import React from 'react'
import styled from 'styled-components'
import { Icon } from 'blocket-ui'
import illustrationSvg from './bostad_rent_illustration.svg'

const Wrapper = styled.div`
  position: relative;
  height: 56px;
  width: 56px;
`

const BostadRentIllustration = () => (
  <Wrapper>
    <Icon icon={illustrationSvg} width={56} height={56} />
  </Wrapper>
)

export default BostadRentIllustration
